import { render } from "./SidebarView.vue?vue&type=template&id=3f1b605a&scoped=true&lang=pug"
import script from "./SidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarView.vue?vue&type=script&setup=true&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=3f1b605a&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1b605a"]])

export default __exports__